import { render, staticRenderFns } from "./PositionInfo.vue?vue&type=template&id=42fb30b4"
import script from "./PositionInfo.vue?vue&type=script&lang=js"
export * from "./PositionInfo.vue?vue&type=script&lang=js"
import style0 from "./PositionInfo.vue?vue&type=style&index=0&id=42fb30b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports